class Authorization {
  static isSignedUpThroughGoogle = (): boolean => window.Checksub.cookies.get('google_signup') === 'true'

  static isLoggedInThroughGoogle = (): boolean => window.Checksub.cookies.get('google_login') === 'true'

  static isSignedUpThroughOauth = (): boolean => Authorization.isSignedUpThroughGoogle()
}

export default Authorization
